import { Link } from "react-router-dom";
import Photo from "../components/ui/Photo";
import { OFFERS } from "../data/salon";
import { faPercent, toman } from "../lib/format";
import { useStagger } from "../lib/motion";
import PageHero from "../components/ui/PageHero";
import { useDocumentTitle } from "../lib/title";
import "./pages.css";

function Ticket({ offer }) {
  return (
    <article
      className="ticket reveal"
      data-stagger=""
      style={{ "--tone": offer.tone, "--tone2": offer.tone2 }}
    >
      <div className="ticket__card">
        <Photo src={offer.photo} alt="" ratio="16 / 7" className="ticket__ph" tint="dusk" />

        <div className="ticket__top">
          <span className="eyebrow">{offer.latin}</span>
          <h3>{offer.title}</h3>
        </div>

        <div className="ticket__value">
          {offer.kind === "percent" ? faPercent(offer.value) : toman(offer.value)}
          <span>تخفیف</span>
        </div>

        {/* perforation */}
        <div className="ticket__perf" aria-hidden="true">
          <span className="ticket__notch ticket__notch--s" />
          <span className="ticket__dash" />
          <span className="ticket__notch ticket__notch--e" />
        </div>

        <div className="ticket__bottom">
          <p>{offer.body}</p>
          <div className="ticket__foot">
            <span className="ticket__until">{offer.until}</span>
            <Link to="/booking" className="tlink">
              رزرو<span className="tlink__arrow">←</span>
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}

export default function Offers() {
  useDocumentTitle("پیشنهادهای ویژه");
  const grid = useStagger({ step: 90 });

  return (
    <>
      <PageHero
        eyebrow="SPECIAL OFFERS"
        title="پیشنهادهای ویژه"
        lede="تخفیف‌ها روی قیمت نهایی اعمال می‌شوند و با هم جمع نمی‌شوند."
        tone="#EFDCE0"
      />

      <section className="section">
        <div className="wrap wrap--wide">
          <div className="tickets" ref={grid}>
            {OFFERS.map((o) => <Ticket key={o.id} offer={o} />)}
          </div>
        </div>
      </section>
    </>
  );
}
